export default "__VITE_ASSET__CcjSwKmE__"